import { i18n } from 'src/i18n';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';
import selectors from 'src/modules/workflowLaunch/list/workflowLaunchListSelectors';
import WorkflowLaunchService from 'src/modules/workflowLaunch/workflowLaunchService';

const prefix = 'WORKFLOWLAUNCH_LIST';

const workflowLaunchListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: workflowLaunchListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({ type: workflowLaunchListActions.RESETED });
    dispatch(workflowLaunchListActions.doFetch());
  },

  doChangePaginationAndSort:
    (pagination, sorter) => async (dispatch) => {
      dispatch({
        type: workflowLaunchListActions.PAGINATION_CHANGED,
        payload: pagination,
      });
      dispatch({
        type: workflowLaunchListActions.SORTER_CHANGED,
        payload: sorter,
      });
      dispatch(
        workflowLaunchListActions.doFetchCurrentFilter(),
      );
    },

  doFetchCurrentFilter:
    () => async (dispatch, getState) => {
      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        workflowLaunchListActions.doFetch(
          filter,
          rawFilter,
          true,
        ),
      );
    },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: workflowLaunchListActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });
        const response = await WorkflowLaunchService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );
        dispatch({
          type: workflowLaunchListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: workflowLaunchListActions.FETCH_ERROR,
        });
      }
    },

  doCopyFetch:
    (filter?, rawFilter?, _keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        const response = await WorkflowLaunchService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: workflowLaunchListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: workflowLaunchListActions.FETCH_ERROR,
        });
      }
    },

  doExport: () => async (dispatch, getState) => {
    try {
      dispatch({
        type: workflowLaunchListActions.EXPORT_STARTED,
      });
      const filter = selectors.selectFilter(getState());
      const response = await WorkflowLaunchService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );
      // Define exporterFields later if needed
      new Exporter(
        [],
        i18n('entities.workflowLaunch.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);
      dispatch({
        type: workflowLaunchListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowLaunchListActions.EXPORT_ERROR,
      });
    }
  },
};

export default workflowLaunchListActions;
